const baseUrl = '/teammembers';
export const teamMembersRoutes = {
  baseUrl: "".concat(baseUrl),
  companyTeamMembers: id => "/companies/".concat(id, "/teammembers"),
  disable: id => "".concat(baseUrl, "/").concat(id, "/disable"),
  enable: id => "".concat(baseUrl, "/").concat(id, "/enable"),
  teamMemberId: teamMemberId => "".concat(baseUrl, "/").concat(teamMemberId)
};